import React from 'react';
import { IconTile } from '@atlaskit/icon';
import Page16Icon from '@atlaskit/icon-object/glyph/page/16';
import PageIcon from '@atlaskit/icon/core/page';
import PageLiveDoc16Icon from '@atlaskit/icon-object/glyph/page-live-doc/16';
import NewIcon from '@atlaskit/icon-lab/core/page-live-doc';

export const contentMenuItemIcon = (isLive: boolean, isVisualRefreshEnabled: boolean) => {
	if (!isLive) {
		return isVisualRefreshEnabled ? (
			<IconTile icon={PageIcon} label="" appearance="blueBold" shape="square" size="16" />
		) : (
			<Page16Icon label="" />
		);
	}
	return isVisualRefreshEnabled ? (
		<IconTile icon={NewIcon} label="" appearance="magentaBold" shape="square" size="16" />
	) : (
		<PageLiveDoc16Icon label="" />
	);
};
